<template>
  <gj-modal
      size="normal"
      class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <div class="header-title-content">
        细化分类：<span class="header-title">{{category}}</span>
      </div>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="84px"
          style="padding: 0 10px;">
        <el-form-item
            label="品牌"
            prop="brandId">
          <gj-select
              v-model="form.brandId"
              :options="brandOption"
              :loading="brandLoading"
              :clearable="false"
              width="300px"
              @input-option="brandInputOption"
          ></gj-select>
        </el-form-item>
        <el-form-item
            label="商品价格范围"
            class="price-input-group">
          <el-form-item
              prop="lowPrice">
            <gj-input
                v-model="form.lowPrice"
                width="180px"
                v-number.price
                placeholder="无最高商品价格">
              <template #prepend>{{currencySymbol}}</template>
            </gj-input>
          </el-form-item>
          <span style="margin: 0 15px">-</span>
          <el-form-item
              prop="maxPrice">
            <gj-input
                v-model="form.maxPrice"
                width="180px"
                v-number.price
                placeholder="无最高商品价格">
              <template #prepend>{{currencySymbol}}</template>
            </gj-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="查看星级评定">
          <el-row type="flex" align="middle">
            <div style="width: 320px; margin-left: 10px;">
              <el-slider
                  v-model="form.marks"
                  range
                  input-size="mini"
                  show-stops
                  :show-tooltip="false"
                  :marks="{
                    0: '0',
                    1: '1',
                    2: '2',
                    3: '3',
                    4: '4',
                    5: '5',
                  }"
                  :max="5">
              </el-slider>
            </div>
            <div style="font-size: 12px;color: #999; margin-left: 18px;">{{form.marks[0]}} - {{form.marks[1]}}星</div>
          </el-row>
        </el-form-item>
        <!-- <el-form-item
            label="配送"
            style="margin: 30px 0 5px;">
          <el-radio-group v-model="form.prime">
            <el-radio label="NO">所有</el-radio>
            <el-radio label="true">具有Prime资格</el-radio>
            <el-radio label="false">不具有Prime资格</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {modalMixIn} from "../../../../../../../../../minxins";
  import {isMeaningful, isMeaningless, transformToMap} from "../../../../../../../../../utils/common";

  export default {
    name: "app-product-target-refine-modal",
    mixins: [modalMixIn],
    props: {
      item: {
        type: Object,
      },
      category: {
        required: true
      },
      currencySymbol: {
        required: true
      },
      brandOption$: {
        required: true
      }
    },
    created() {
      // if (isMeaningful(this.item)) {
        // Object.assign(this.form, this.item);
      // }
      this.brandLoading = true;
      this.brandOption$
        .then(({ data }) => {
           this.brandOption = data.map(e => ({
             ...e,
             text: e.name
           }));
        })
        .complete(() => this.brandLoading = false);
    },
    data() {
      return {
        brandOption: [],
        form: {
          brandId: null,
          brandName: null,
          lowPrice: null,
          maxPrice: null,
          marks: [0, 5],
          prime: 'NO'
        },
        brandLoading: false
      }
    },
    methods: {
      brandInputOption(option) {
        this.form.brandName = option.name;
      },
      confirm() {
        if (isMeaningless(this.form.brandId)
          && isMeaningless(this.form.lowPrice)
          && isMeaningless(this.form.maxPrice)) {
          this.$gjMessage.error('品牌、最高商品价格、最低商品价格至少填一项');
          return;
        }
        this.$emit('refine');
        this.$gjDestroy();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modalClass {
    /deep/.gj-modal--normal {
        .el-dialog {
          width: 520px !important;
        }
      }
  }
  .header-title-content {
    font-weight: normal !important;
    font-size: 12px;
    .header-title {
      color: #666;
    }
  }
  .header-title {
    color: #909399;
    font-size: 12px;
  }
  /deep/ .price-input-group .el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-slider__button {
    width: 12px;
    height: 12px;
  }
   /deep/.gj-modal--normal .el-dialog {
      width: 500px !important;
      height: 371px !important;
  }
  /deep/ .el-form-item__label {
    font-size: 12px;
    color: #666;
    padding-bottom: 0;
  }
  /deep/.el-form {
    padding: 0 !important;
  }
  /deep/.el-input__inner {
    font-size: 12px;
    &::placeholder {
      font-size: 12px;
      color: #999;
    }
  }
  /deep/.el-slider__marks-text {
    color: #999;
  }
</style>




